import { cn } from "@/lib/utils";
import { parseIsoDate } from "@/lib/dateInput";

interface DateDisplayProps {
  date: unknown;
  locale?: string;
  className?: string;
}

function parseDisplayDate(date: unknown): Date | undefined {
  if (date instanceof Date) {
    return Number.isNaN(date.getTime()) ? undefined : date;
  }

  if (typeof date === "string") {
    const dateOnly = parseIsoDate(date);
    if (dateOnly) return dateOnly;

    const parsed = new Date(date);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }

  const parsed = new Date(String(date));
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

export default function DateDisplay({
  date,
  locale = "pt-BR",
  className,
}: DateDisplayProps) {
  const parsed = parseDisplayDate(date);
  if (!parsed) return null;

  const formatter = new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return (
    <span className={cn("text-sm text-primary-600 dark:text-primary-400", className)}>
      {formatter.format(parsed)}
    </span>
  );
}
